export class Family {
  id?: number;

  code?: string;
  label?: string;

  constructor(data = {}) {
    Object.assign(this, data);
  }
}
